import * as Yup from 'yup';

export const cancelInspectionProcessSchema = () => {
    return (
        Yup.object({
            note: Yup.string()
                .trim()
                .required('Note is required')
        }))
};
